export const lessonSteps = state => {
  return state.lessonStep.allIds.map(id => state.lessonStep.byId[id])
}

// current lesson step depending on the router path
export const currentLessonStep = (state, getters, rootState) => {
  const lessonStepId = rootState.route.params.lessonStepId

  if (!lessonStepId) {
    return null
  }

  return state.lessonStep.byId[lessonStepId]
}

// current lesson depending on the router path
export const currentLesson = (state, getters, rootState) => {
  const lessonId = rootState.route.params.lessonId

  if (!lessonId) {
    return null
  }

  return state.lesson.byId[lessonId]
}

export const currentThemeLessonSteps = (state, getters) => {
  const theme = getters.currentTheme

  if (!theme) {
    return null
  }

  return theme.lessonSteps.map(id => state.lessonStep.byId[id])
}

// computes the lesson step progression
// IOT return the current lesson and the number of lessons
export const lessonStepProgression = (state, getters, rootState) => {
  if (rootState.route.name !== 'lesson') {
    return null
  }

  const currentLessonStep = getters.currentLessonStep

  if (!currentLessonStep) {
    return null
  }

  const numberOfLessons = currentLessonStep.lessons.length

  const currentLessonId = rootState.route.params.lessonId
  const currentLesson = currentLessonStep.lessons.indexOf(currentLessonId) + 1

  return { currentLesson, numberOfLessons }
}

// compute the duration for a single lesson
export const lessonDuration = state => lessonId => {
  const lesson = state.lesson.byId[lessonId]

  return lesson.duration || 0
}

// compute the lessonStep duration from the lesson duration
export const lessonStepDuration = state => lessonStepId => {
  const lessonStep = state.lessonStep.byId[lessonStepId]
  const lessonIds = (lessonStep && lessonStep.lessons) || []

  return lessonIds.reduce((duration, lessonId) => {
    const lesson = state.lesson.byId[lessonId]

    if (!lesson.duration) return duration

    return duration + lesson.duration
  }, 0)
}

export const lessonFirebaseID = state => state.firebaseId

export const currentLessonsForLessonStep = (state, getters) => {
  const lessonStep = getters.currentLessonStep

  if (!lessonStep) return null

  return lessonStep.lessons.map(id => state.lesson.byId[id])
}
